import { useAuth } from "contexts/AuthProvider";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const SignOutCallback = () => {
  const { finishLogout } = useAuth();
  const [redirect, setRedirect] = useState(null as any);

  useEffect(() => {
    finishLogout().then(_ => {
      setRedirect('/order/logout');
    });
  }, []);
  return redirect ? <Navigate to={redirect} /> : <></>;
}

export default SignOutCallback;